var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"growth-predict-block"},[_c('div',{staticClass:"chart-growth-predict",attrs:{"id":_vm.chartID}}),(_vm.clickedStage)?_c('div',[_vm._v("\n        "+_vm._s(_vm.clickedStage)+"\n    ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }